<div mat-dialog-title class="flex items-start justify-between w-full mt-3">
  <div class="flex flex-col items-start flex-1">
    <span class="font-bold text-2xl primary-color">Información académica</span>
    <span class="text-sm text-gray-500">Los campos marcados con * son obligatorios.</span>
  </div>
  <div class="flex items-center pr-1">
    <!-- <i class="pi pi-exclamation-triangle danger-color" style="font-size: 3rem"></i> -->
  </div>
</div>
<mat-dialog-content>
  <form [formGroup]="form" miForm class="styled-form p-fluid">
    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('idNivAca', 'El nivel académico es requerido')">
      <label>Nivel académico *</label>
      <p-select
        formControlName="idNivAca"
        [options]="academicLevelsList"
        placeholder="Nivel académico"
        [filter]="true"
        [filterBy]="'label,id'"
        [optionValue]="'id'"
        [optionLabel]="'label'"
        appendTo="body"
      ></p-select>
    </div>
    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('nomInst', 'El nombre de la institución es requerido')">
      <label for="nomInst">Institución *</label>
      <input pInputText formControlName="nomInst" placeholder="Institución" />
    </div>

    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('programa', 'El programa es requerido')">
      <label>Programa*</label>
      <input pInputText formControlName="programa" placeholder="Programa" />
    </div>

    <div [miCol]="6" miFormField>
      <mat-checkbox formControlName="actEst">
        <label for="actEst">¿Este programa lo estás cursando actualmente?</label>
      </mat-checkbox>
    </div>

    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('mesIni', 'El mes de inicio es requerido')">
      <label>Mes de inicio *</label>
      <p-select
        formControlName="mesIni"
        [options]="monthsList"
        placeholder="Mes de inicio"
        [filter]="true"
        [filterBy]="'label,id'"
        [optionValue]="'id'"
        appendTo="body"
      ></p-select>
    </div>

    <div [miCol]="6" miFormField [miFormFieldError]="getErrorMessage('anoIni', 'El año de inicio es requerido')">
      <label>Año de inicio *</label>
      <p-select
        formControlName="anoIni"
        [options]="yearsList"
        placeholder="Año de inicio"
        [filter]="true"
        [filterBy]="'label,id'"
        [optionValue]="'id'"
        appendTo="body"
      ></p-select>
    </div>

    @if (!form.get('actEst')?.value) {
    <div
      [miCol]="6"
      miFormField
      [miFormFieldError]="getErrorMessage('mesFin', 'El mes de finalización es requerido')"
    >
      <label>Mes de finalización *</label>
      <p-select
        formControlName="mesFin"
        [options]="monthsList"
        placeholder="Mes de finalización"
        [filter]="true"
        [filterBy]="'label,id'"
        [optionValue]="'id'"
        appendTo="body"
      ></p-select>
    </div>
    }

    @if (!form.get('actEst')?.value) {
    <div
      [miCol]="6"
      miFormField
      [miFormFieldError]="getErrorMessage('anoFin', 'El año de finalización es requerido')"
    >
      <label>Año de finalización *</label>
      <p-select
        formControlName="anoFin"
        [options]="yearsList"
        placeholder="Año de finalización"
        [filter]="true"
        [filterBy]="'label,id'"
        [optionValue]="'id'"
        appendTo="body"
      ></p-select>
    </div>
    }
  </form>
  <mat-dialog-actions class="flex justify-content-end gap-2 p-0">
    <button miButton="back" [miButtonIcon]="'solar:close-circle-broken'" (click)="closeDialog(false)">Cerrar</button>
    <button miButton="primary" [disabled]="form.invalid" type="submit" (click)="isEdit ? onEdit() : onCreate()">
      {{ isEdit ? 'Actualizar' : 'Guardar' }}
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
